<script setup>
import { useInvoiceStore } from '@organisms/ubiq-administration/store/invoices';
import { useAccountStore } from '../store/account';
import UbiqDataView from '../../../_01_atoms/components/UbiqDataView.vue';
import { trans } from '../../../_00_elements/translation';
import { currency } from '../../../_00_elements/number-formatter';
import CardEmptyTable from '../general/CardEmptyTable.vue';
import UbiqInvoiceMenu from './menu/UbiqInvoiceMenu.vue';
import InvoiceStatusTag from './tags/InvoiceStatusTag.vue';

const invoiceStore = useInvoiceStore();
const accountStore = useAccountStore();

invoiceStore.setInvoices(window.initialState.invoices);
accountStore.setStripeAccountStatus(window.initialState.stripeAccountStatus);
</script>

<template>
  <UbiqDataView>
    <template #list-item="{ item }">
      <div class="dataview__row">
        <div class="dataview__row-informations">
          <div class="dataview-cell-flex">
            <div class="column--bold">
              {{ currency(item.amount / 100) }}
            </div>
            <InvoiceStatusTag :status="item.status?.toLowerCase()" />
          </div>
          <div>
            {{ trans(`gestion.invoices.type.${item.invoice_type}`) }}
          </div>
          <div>
            {{ item.invoice_number || '-' }}
          </div>
        </div>

        <div class="simple-table__column--actions">
          <UbiqInvoiceMenu :invoice="item" />
        </div>
      </div>
    </template>
    <template #empty-state>
      <CardEmptyTable
        logo="ph_coins_blue"
        :title="trans('gestion.invoice.empty.title')"
        :subtitle="trans('gestion.invoice.empty.subtitle')"
      />
    </template>
    <template #empty>
      {{ trans('gestion.subscription.step.1.no_result') }}
    </template>
  </UbiqDataView>
</template>
